import { Campaign, LocalActivity, Redeem, Storefront } from "@mui/icons-material";

export const GiftStatusEnum = {
    ANNOUNCED: {
      label: 'Announced',
      status: 1,
      icon: <Campaign />,
      color: '#F49D3F',
    },
    IN_SHOP: {
      label: 'In Shop',
      status: 2,
      icon: <Storefront />,
      color: '#7F00BB',
    },
    GIFTED: { label: 'Gifted', status: 3, icon: <Redeem />, color: '#7CEA9C' },
    REDEEMED: {
      label: 'Redeemed',
      status: 4,
      icon: <LocalActivity />,
      color: '#01522B',
    },
};
  
export const REWARD_TABS = {
  SELF: 'SELF',
  INFLUENCER: 'INFLUENCER',
  NETWORK: 'NETWORK',
  NETWORK_INFLUENCER: 'NETWORK INFLUENCER',
}